import buildSignature from './signature';
import buildHouseholdInformation from './householdInformation';
import buildStudentInformation from './studentInformation';
import buildEmploymentInformation, {
  buildCurrentEmployer,
  buildEmploymentChange,
  buildPreviousEmployer,
  buildSecondEmployer,
} from './employment';

/**
 * The fields of the legacy Recert Application as a starting point for the new form. Rules and
 * dynamic displays come later, apart from the ones that keep the form restricted like the legacy
 * one: the household answers are for the primary applicant, a locked certification is read-only,
 * and some questions are disabled by the answers above them.
 */
const buildRecertSchema = ({
  isPrimary,
  isLocked = false,
  notEmployedStatusId,
  employedStatusId,
}) => [
  {
    name: 'recertApplicationForm',
    container: 'default',
    fields: [
      {
        name: 'mainFields',
        container: 'default',
        border: true,
        fields: [
          {
            name: 'recertApplication',
            title: 'Recert Application',
            container: 'default',
            divider: true,
            // A locked certification cannot be edited at all.
            disabled: isLocked,
            fields: [
              // Household answers only apply to the primary applicant.
              ...(isPrimary ? [buildHouseholdInformation({ isLocked })] : []),
              buildStudentInformation({ isLocked, employedStatusId }),
              buildEmploymentInformation({
                isLocked,
                notEmployedStatusId,
                employedStatusId,
              }),
              buildCurrentEmployer({
                isLocked,
                notEmployedStatusId,
                employedStatusId,
              }),
              buildSecondEmployer({ isLocked, notEmployedStatusId }),
              buildEmploymentChange({ isLocked, employedStatusId }),
              buildPreviousEmployer({ isLocked }),
              buildSignature({ isLocked }),
            ],
          },
        ],
      },
    ],
  },
];

export default buildRecertSchema;
